import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-background py-6 sm:py-8 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <div>
            <p className="text-[10px] sm:text-sm lg:text-xs text-muted-foreground">© 2025 VTranslate</p>
          </div>
          <div className="flex space-x-4 sm:space-x-6">
            <Link to="/privacy-policy" className="text-[10px] sm:text-sm lg:text-xs text-muted-foreground hover:text-foreground">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="text-[10px] sm:text-sm lg:text-xs text-muted-foreground hover:text-foreground">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;